<!--
  AI:
  Status: "in progress"
  Type: Component
  SubType: CrudIntegration
  Reason: "Bipro" conditional navigation point — read-only Exchange config tabs (no create buttons)
    plus the Austausch-Werkzeuge panels. Every tab body is @if-guarded on the active tab (CONFIG-022).
    CW-EXCHANGE-V2: the Binding-Gruppen / Feld-Bindungen / Struktur-Knoten / Produkt-Fragmente tabs are
    gone with their entities; Antwort-Zuordnungen is the new response-side member.
-->
<div class="cw-bipro p-2">
    <p-tabs [value]="activeTab" (valueChange)="onTabChange($event)" [scrollable]="true">
        <p-tablist>
            <p-tab value="bipro">Bipro</p-tab>
            <p-tab value="exchange">Austausch-Definitionen</p-tab>
            <p-tab value="skeletons">Skeleton</p-tab>
            <p-tab value="fieldDefinitions">Zusatzfelder</p-tab>
            <p-tab value="responseMappings">Antwort-Zuordnungen</p-tab>
            <p-tab value="echoRules">Echo-Regeln</p-tab>
            <p-tab value="tools">Werkzeuge</p-tab>
        </p-tablist>

        <p-tabpanels>

            <!-- Bipro (single-row coordinate) -->
            <p-tabpanel value="bipro">
                @if (activeTab === 'bipro' && biproWidget) {
                    <mvs-widget [widgetData]="biproWidget"></mvs-widget>
                }
            </p-tabpanel>

            <!-- Austausch-Definitionen (Operations-Anker je Vorgangstyp) -->
            <p-tabpanel value="exchange">
                @if (activeTab === 'exchange' && exchangeDefinitionWidget) {
                    <mvs-widget [widgetData]="exchangeDefinitionWidget"></mvs-widget>
                }
            </p-tabpanel>

            <!-- Skeleton (genau eines je Vorgangstyp, deckt alle Operationen ab) -->
            <p-tabpanel value="skeletons">
                @if (activeTab === 'skeletons' && skeletonWidget) {
                    <mvs-widget [widgetData]="skeletonWidget"></mvs-widget>
                }
            </p-tabpanel>

            <!-- Zusatzfelder (Konstanten + berechnete Felder) -->
            <p-tabpanel value="fieldDefinitions">
                @if (activeTab === 'fieldDefinitions' && fieldDefinitionWidget) {
                    <mvs-widget [widgetData]="fieldDefinitionWidget"></mvs-widget>
                }
            </p-tabpanel>

            <!-- Antwort-Zuordnungen (Rückschreiben aus der Versicherer-Antwort) -->
            <p-tabpanel value="responseMappings">
                @if (activeTab === 'responseMappings' && responseMappingWidget) {
                    <mvs-widget [widgetData]="responseMappingWidget"></mvs-widget>
                }
            </p-tabpanel>

            <!--
              Echo-Regeln (pfadbezogene Regeln des Echo-/Quelle-Kanals).
              #C.1: die Tabelle zeigt die VEREINIGUNG aus den Regeln dieses Vorgangstyps und den
              Regeln, die er von seiner Partei-Version erbt. Geerbte Zeilen tragen das Kennzeichen
              „Partei-Version“ und werden hier NICHT bearbeitet.
            -->
            <p-tabpanel value="echoRules">
                @if (activeTab === 'echoRules') {

                    @if (hasInheritedScope()) {
                        <div class="flex align-items-start gap-2 p-3 mb-2 border-round surface-100 text-color-secondary">
                            <i class="fa-solid fa-circle-info mt-1"></i>
                            <div class="flex flex-column align-items-start gap-2">
                                <span>{{ scopeInheritanceHint }}</span>
                                <!-- Der Hinweis nennt die Fläche nicht nur, er öffnet sie MIT der
                                     Partei-Version dieses Vorgangstyps bereits ausgewaehlt. -->
                                <p-button [label]="openPartyVersionConfigLabel"
                                          icon="fa-solid fa-layer-group"
                                          severity="secondary"
                                          [text]="true"
                                          size="small"
                                          (onClick)="openPartyVersionConfig()">
                                </p-button>
                            </div>
                        </div>
                    }

                    <div class="flex align-items-start gap-2 p-3 mb-2 border-round surface-100 text-color-secondary">
                        <i class="fa-solid fa-triangle-exclamation mt-1"></i>
                        <span>{{ fieldReferenceHint }}</span>
                    </div>

                    @if (echoRuleWidget) {
                        <mvs-widget [widgetData]="echoRuleWidget">
                            <!--
                              Geltungsbereich-Spalte: die fieldId MUSS CW_SCOPE_CUSTOM_FIELD_ID sein,
                              sonst findet widget.service.ts kein Template und lässt die Spalte
                              KOMMENTARLOS weg (isCustomTemplateField -> continue).
                            -->
                            <ng-template mvs-widget-custom-field-directive
                                         area="columns"
                                         [fieldId]="scopeCustomFieldId"
                                         [label]="scopeColumnLabel"
                                         let-object="object">
                                <mvs-cw-carrier-scope-badge [object]="object"></mvs-cw-carrier-scope-badge>
                            </ng-template>
                        </mvs-widget>
                    }
                }
            </p-tabpanel>

            <!-- Austausch-Werkzeuge -->
            <p-tabpanel value="tools">
                @if (activeTab === 'tools') {
                    <div class="grid">
                        <div class="col-12">
                            <cw-exchange-config-check-panel
                                [caseTypeId]="caseTypeId"
                                [flow]="caseTypeBiproFlow">
                            </cw-exchange-config-check-panel>
                        </div>
                        <div class="col-12">
                            <cw-exchange-render-preview-panel></cw-exchange-render-preview-panel>
                        </div>
                    </div>
                }
            </p-tabpanel>

        </p-tabpanels>
    </p-tabs>
</div>
